import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const createVendor = createAsyncThunk(
    'partVendors/createVendor',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createVendor(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create Vendor');
        }
    }
);

export const createWarehouse = createAsyncThunk(
    'partVendors/createWarehouse',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createWarehouse(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create Warehouse');
        }
    }
);

export const getVendorsPaginated = createAsyncThunk(
    'partVendors/getVendorsPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getVendorsPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Vendors');
        }
    }
);

export const getWarehousesPaginated = createAsyncThunk(
    'partVendors/getWarehousesPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehousesPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Warehouses');
        }
    }
);

export const deleteVendor = createAsyncThunk(
    'partVendors/deleteVendor',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteVendor(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete Vendor');
        }
    }
);

export const deleteWarehouse = createAsyncThunk(
    'partVendors/deleteWarehouse',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteWarehouse(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete Warehouse');
        }
    }
);

export const updateVendor = createAsyncThunk(
    'partVendors/updateVendor',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updatePartVendor(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update Vendor');
        }
    }
);

export const getVendorDetail = createAsyncThunk(
    'partVendors/getVendorDetail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getVendorDetail(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Vendor details');
        }
    }
);

export const getWarehouseDetail = createAsyncThunk(
    'partVendors/getWarehouseDetail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehouseDetail(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Warehouse details');
        }
    }
);

export const updateWarehouse = createAsyncThunk(
    'partVendors/updateWarehouse',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateWarehouse(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update Warehouse');
        }
    }
);

export const getWarehousePartsPaginated = createAsyncThunk(
    'partVendors/getWarehousePartsPaginated',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehousePartsPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch warehouse inventory');
        }
    }
);

export const getStockMovementInfo = createAsyncThunk(
    'partVendors/getStockMovementInfo',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getStockMovementInfo(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch stock movement info');
        }
    }
);

export const deleteStockMovementInfo = createAsyncThunk(
    'partVendors/deleteStockMovementInfo',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteStockMovementInfo(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete stock movement');
        }
    }
);

export const changeStockMovementStatus = createAsyncThunk(
    'partVendors/changeStockMovementStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.changeStockMovementStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to change stock movement status');
        }
    }
);

export const getWarehousesDropdown = createAsyncThunk(
    'partVendors/getWarehousesDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehousesDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch warehouses dropdown');
        }
    }
);

export const getPartsByWarehouse = createAsyncThunk(
    'partVendors/getPartsByWarehouse',
    async (warehouseId, { rejectWithValue }) => {
        try {
            const response = await apiService.getPartsByWarehouse(warehouseId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch warehouse parts');
        }
    }
);

export const getWarehousesWithPartStock = createAsyncThunk(
    'partVendors/getWarehousesWithPartStock',
    async (partId, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehousesWithPartStock(partId);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch warehouses with part stock');
        }
    }
);

export const createWarehouseStockTransfer = createAsyncThunk(
    'partVendors/createWarehouseStockTransfer',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createWarehouseStockTransfer(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create stock transfer');
        }
    }
);

export const getVendorOverview = createAsyncThunk(
    'partVendors/getVendorOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVendorOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Vendor Overview');
        }
    }
);

export const getWarehouseOverview = createAsyncThunk(
    'partVendors/getWarehouseOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getWarehouseOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Warehouse Overview');
        }
    }
);

const initialState = {
    createVendorLoading: false,
    createVendorError: null,
    updateVendorLoading: false,
    updateVendorError: null,
    createWarehouseLoading: false,
    createWarehouseError: null,
    getVendorsPaginatedData: null,
    getVendorsLoading: false,
    getVendorsError: null,
    getWarehousesPaginatedData: null,
    getWarehousesLoading: false,
    getWarehousesError: null,
    deleteVendorLoading: false,
    deleteVendorError: null,
    deleteWarehouseLoading: false,
    deleteWarehouseError: null,
    getVendorDetailLoading: false,
    getVendorDetailError: null,
    vendorDetail: null,
    vendorOverview: null,
    getVendorOverviewLoading: false,
    getVendorOverviewError: null,
    getWarehouseDetailLoading: false,
    getWarehouseDetailError: null,
    warehouseDetail: null,
    updateWarehouseLoading: false,
    updateWarehouseError: null,
    warehousePartsPaginatedData: null,
    getWarehousePartsLoading: false,
    getWarehousePartsError: null,
    stockMovementInfoData: null,
    getStockMovementInfoLoading: false,
    getStockMovementInfoError: null,
    warehousesDropdownData: [],
    getWarehousesDropdownLoading: false,
    getWarehousesDropdownError: null,
    warehousesWithPartStockData: [],
    getWarehousesWithPartStockLoading: false,
    getWarehousesWithPartStockError: null,
    warehousePartsListData: [],
    getPartsByWarehouseLoading: false,
    getPartsByWarehouseError: null,
    createWarehouseStockTransferLoading: false,
    createWarehouseStockTransferError: null,
    deleteStockMovementInfoLoading: false,
    deleteStockMovementInfoError: null,
    warehouseOverview: null,
    getWarehouseOverviewLoading: false,
    getWarehouseOverviewError: null,
}

const partVendorSlice = createSlice({
    name: 'partVendors',
    initialState,
    reducers: {
        clearWarehousesWithPartStock: (state) => {
            state.warehousesWithPartStockData = [];
            state.getWarehousesWithPartStockLoading = false;
            state.getWarehousesWithPartStockError = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createVendor.pending, (state) => {
                state.createVendorLoading = true;
                state.createVendorError = null;
            })
            .addCase(createVendor.fulfilled, (state, action) => {
                state.createVendorLoading = false;
                state.createVendorError = null;
            })
            .addCase(createVendor.rejected, (state, action) => {
                state.createVendorLoading = false;
                state.createVendorError = action.payload;
            })
            .addCase(updateVendor.pending, (state) => {
                state.updateVendorLoading = true;
                state.updateVendorError = null;
            })
            .addCase(updateVendor.fulfilled, (state, action) => {
                state.updateVendorLoading = false;
                state.updateVendorError = null;
            })
            .addCase(updateVendor.rejected, (state, action) => {
                state.updateVendorLoading = false;
                state.updateVendorError = action.payload;
            })
            .addCase(createWarehouse.pending, (state) => {
                state.createWarehouseLoading = true;
                state.createWarehouseError = null;
            })
            .addCase(createWarehouse.fulfilled, (state, action) => {
                state.createWarehouseLoading = false;
                state.createWarehouseError = null;
            })
            .addCase(createWarehouse.rejected, (state, action) => {
                state.createWarehouseLoading = false;
                state.createWarehouseError = action.payload;
            })
            .addCase(getVendorsPaginated.pending, (state) => {
                state.getVendorsLoading = true;
                state.getVendorsError = null;
            })
            .addCase(getVendorsPaginated.fulfilled, (state, action) => {
                state.getVendorsLoading = false;
                state.getVendorsPaginatedData = action.payload?.data;
                state.getVendorsError = null;
            })
            .addCase(getVendorsPaginated.rejected, (state, action) => {
                state.getVendorsLoading = false;
                state.getVendorsError = action.payload;
            })
            .addCase(getWarehousesPaginated.pending, (state) => {
                state.getWarehousesLoading = true;
                state.getWarehousesError = null;
            })
            .addCase(getWarehousesPaginated.fulfilled, (state, action) => {
                state.getWarehousesLoading = false;
                state.getWarehousesPaginatedData = action.payload?.data;
                state.getWarehousesError = null;
            })
            .addCase(getWarehousesPaginated.rejected, (state, action) => {
                state.getWarehousesLoading = false;
                state.getWarehousesError = action.payload;
            })
            .addCase(deleteVendor.pending, (state) => {
                state.deleteVendorLoading = true;
                state.deleteVendorError = null;
            })
            .addCase(deleteVendor.fulfilled, (state, action) => {
                state.deleteVendorLoading = false;
                state.deleteVendorError = null;
            })
            .addCase(deleteVendor.rejected, (state, action) => {
                state.deleteVendorLoading = false;
                state.deleteVendorError = action.payload;
            })
            .addCase(deleteWarehouse.pending, (state) => {
                state.deleteWarehouseLoading = true;
                state.deleteWarehouseError = null;
            })
            .addCase(deleteWarehouse.fulfilled, (state, action) => {
                state.deleteWarehouseLoading = false;
                state.deleteWarehouseError = null;
            })
            .addCase(deleteWarehouse.rejected, (state, action) => {
                state.deleteWarehouseLoading = false;
                state.deleteWarehouseError = action.payload;
            })
            .addCase(getVendorDetail.pending, (state) => {
                state.getVendorDetailLoading = true;
                state.getVendorDetailError = null;
            })
            .addCase(getVendorDetail.fulfilled, (state, action) => {
                state.getVendorDetailLoading = false;
                state.vendorDetail = action.payload?.data;
                state.getVendorDetailError = null;
            })
            .addCase(getVendorDetail.rejected, (state, action) => {
                state.getVendorDetailLoading = false;
                state.getVendorDetailError = action.payload;
            })
            .addCase(getVendorOverview.pending, (state) => {
                state.getVendorOverviewLoading = true;
                state.getVendorOverviewError = null;
            })
            .addCase(getVendorOverview.fulfilled, (state, action) => {
                state.getVendorOverviewLoading = false;
                state.vendorOverview = action.payload?.data;
                state.getVendorOverviewError = null;
            })
            .addCase(getVendorOverview.rejected, (state, action) => {
                state.getVendorOverviewLoading = false;
                state.getVendorOverviewError = action.payload;
            })
            .addCase(getWarehouseDetail.pending, (state) => {
                state.getWarehouseDetailLoading = true;
                state.getWarehouseDetailError = null;
            })
            .addCase(getWarehouseDetail.fulfilled, (state, action) => {
                state.getWarehouseDetailLoading = false;
                state.warehouseDetail = action.payload?.data;
                state.getWarehouseDetailError = null;
            })
            .addCase(getWarehouseDetail.rejected, (state, action) => {
                state.getWarehouseDetailLoading = false;
                state.getWarehouseDetailError = action.payload;
            })
            .addCase(updateWarehouse.pending, (state) => {
                state.updateWarehouseLoading = true;
                state.updateWarehouseError = null;
            })
            .addCase(updateWarehouse.fulfilled, (state, action) => {
                state.updateWarehouseLoading = false;
                state.updateWarehouseError = null;
            })
            .addCase(updateWarehouse.rejected, (state, action) => {
                state.updateWarehouseLoading = false;
                state.updateWarehouseError = action.payload;
            })
            .addCase(getWarehousePartsPaginated.pending, (state) => {
                state.getWarehousePartsLoading = true;
                state.getWarehousePartsError = null;
            })
            .addCase(getWarehousePartsPaginated.fulfilled, (state, action) => {
                state.getWarehousePartsLoading = false;
                state.warehousePartsPaginatedData = action.payload?.data;
                state.getWarehousePartsError = null;
            })
            .addCase(getWarehousePartsPaginated.rejected, (state, action) => {
                state.getWarehousePartsLoading = false;
                state.getWarehousePartsError = action.payload;
            })
            .addCase(getStockMovementInfo.pending, (state) => {
                state.getStockMovementInfoLoading = true;
                state.getStockMovementInfoError = null;
            })
            .addCase(getStockMovementInfo.fulfilled, (state, action) => {
                state.getStockMovementInfoLoading = false;
                state.stockMovementInfoData = action.payload?.data;
                state.getStockMovementInfoError = null;
            })
            .addCase(getStockMovementInfo.rejected, (state, action) => {
                state.getStockMovementInfoLoading = false;
                state.getStockMovementInfoError = action.payload;
            })
            .addCase(getWarehousesDropdown.pending, (state) => {
                state.getWarehousesDropdownLoading = true;
                state.getWarehousesDropdownError = null;
            })
            .addCase(getWarehousesDropdown.fulfilled, (state, action) => {
                state.getWarehousesDropdownLoading = false;
                state.warehousesDropdownData = action.payload?.data || [];
                state.getWarehousesDropdownError = null;
            })
            .addCase(getWarehousesDropdown.rejected, (state, action) => {
                state.getWarehousesDropdownLoading = false;
                state.getWarehousesDropdownError = action.payload;
            })
            .addCase(getPartsByWarehouse.pending, (state) => {
                state.getPartsByWarehouseLoading = true;
                state.getPartsByWarehouseError = null;
            })
            .addCase(getPartsByWarehouse.fulfilled, (state, action) => {
                state.getPartsByWarehouseLoading = false;
                state.warehousePartsListData = action.payload?.data || [];
                state.getPartsByWarehouseError = null;
            })
            .addCase(getPartsByWarehouse.rejected, (state, action) => {
                state.getPartsByWarehouseLoading = false;
                state.getPartsByWarehouseError = action.payload;
                state.warehousePartsListData = [];
            })
            .addCase(getWarehousesWithPartStock.pending, (state) => {
                state.getWarehousesWithPartStockLoading = true;
                state.getWarehousesWithPartStockError = null;
                state.warehousesWithPartStockData = [];
            })
            .addCase(getWarehousesWithPartStock.fulfilled, (state, action) => {
                state.getWarehousesWithPartStockLoading = false;
                state.warehousesWithPartStockData = action.payload?.data || [];
                state.getWarehousesWithPartStockError = null;
            })
            .addCase(getWarehousesWithPartStock.rejected, (state, action) => {
                state.getWarehousesWithPartStockLoading = false;
                state.getWarehousesWithPartStockError = action.payload;
                state.warehousesWithPartStockData = [];
            })
            .addCase(createWarehouseStockTransfer.pending, (state) => {
                state.createWarehouseStockTransferLoading = true;
                state.createWarehouseStockTransferError = null;
            })
            .addCase(createWarehouseStockTransfer.fulfilled, (state) => {
                state.createWarehouseStockTransferLoading = false;
                state.createWarehouseStockTransferError = null;
            })
            .addCase(createWarehouseStockTransfer.rejected, (state, action) => {
                state.createWarehouseStockTransferLoading = false;
                state.createWarehouseStockTransferError = action.payload;
            })
            .addCase(deleteStockMovementInfo.pending, (state) => {
                state.deleteStockMovementInfoLoading = true;
                state.deleteStockMovementInfoError = null;
            })
            .addCase(deleteStockMovementInfo.fulfilled, (state) => {
                state.deleteStockMovementInfoLoading = false;
                state.deleteStockMovementInfoError = null;
            })
            .addCase(deleteStockMovementInfo.rejected, (state, action) => {
                state.deleteStockMovementInfoLoading = false;
                state.deleteStockMovementInfoError = action.payload;
            })
            .addCase(getWarehouseOverview.pending, (state) => {
                state.getWarehouseOverviewLoading = true;
                state.getWarehouseOverviewError = null;
            })
            .addCase(getWarehouseOverview.fulfilled, (state, action) => {
                state.getWarehouseOverviewLoading = false;
                state.warehouseOverview = action.payload?.data;
                state.getWarehouseOverviewError = null;
            })
            .addCase(getWarehouseOverview.rejected, (state, action) => {
                state.getWarehouseOverviewLoading = false;
                state.getWarehouseOverviewError = action.payload;
            })
    },
});

export const { clearWarehousesWithPartStock } = partVendorSlice.actions;

export default partVendorSlice.reducer;
